import React from 'react';
import { useIntl } from '@atlassian/jira-intl';
import { FireScreenAnalytics } from '@atlassian/jira-product-analytics-bridge';
import { TaskDescription } from '../components/TaskDescription.tsx';
import { TaskDescriptionParagraph } from '../components/TaskDescriptionParagraph.tsx';
import { ShowMeButton } from '../components/ShowMeButton.tsx';
import { TaskCompleteButton } from '../components/TaskCompleteButton.tsx';
import { SHARE_AND_COLLABORATE_TOUR_STEP_1_SPOTLIGHT_ID } from '../ui/spotlights/share-and-collaborate/constants.tsx';
import { useActions, useCanShareViews } from '../services/index.tsx';
import TaskDescriptionRoleRestrictions from '../components/TaskDescriptionRoleRestrictions.tsx';
import { messages } from './shareAndCollaborate.messages.tsx';
import { TASK_SHARE_AND_COLLABORATE } from './constants.tsx';
import type { TaskDefinition } from './types.tsx';

const Description = () => {
	const { formatMessage } = useIntl();
	const { setSpotlightStepId } = useActions();
	const canShareViews = useCanShareViews();

	return (
		<TaskDescription>
			<FireScreenAnalytics attributes={{ taskId: TASK_SHARE_AND_COLLABORATE }} />
			<TaskDescriptionParagraph>{formatMessage(messages.description)}</TaskDescriptionParagraph>
			<TaskDescriptionRoleRestrictions description={formatMessage(messages.roleRestrictionsText)} />
			{canShareViews ? (
				<ShowMeButton
					onClick={() => setSpotlightStepId(SHARE_AND_COLLABORATE_TOUR_STEP_1_SPOTLIGHT_ID)}
					taskId={TASK_SHARE_AND_COLLABORATE}
				/>
			) : (
				<TaskCompleteButton taskId={TASK_SHARE_AND_COLLABORATE} />
			)}
		</TaskDescription>
	);
};

export const shareAndCollaborate = {
	id: TASK_SHARE_AND_COLLABORATE,
	title: messages.title,
	description: <Description />,
} satisfies TaskDefinition;
